import { Component, OnInit } from '@angular/core';
import { SystemEventsWorkflowService, SystemEvent, UpdateTriggerEventActionRequest, SystemEventActionTypeEnum, WorkflowEventTriggered, SystemEventTriggeredActionDto, } from 'src/app/Services/system-events-workflow/system-events-workflow.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationTypes } from 'src/app/app.enums';
import { SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { EmailEventTypeService } from 'src/app/Services/email-event-type.service';
import { EmailEventsFilters } from 'src/app/Services/auth.service';
import { EmailEventsService } from '../../../Services/email-events.service';
import { Events, Parameters, SaveTemplates, Templates } from 'src/app/models/emailevents.model';
import { SmsTemplatePayload, SmsTemplateService } from 'src/app/Services/sms-template-service/sms-template.service';
import { InputSwitchOnChangeEvent } from 'primeng/inputswitch';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-system-events-workflow',
    templateUrl: './system-events-workflow.component.html',
    styleUrls: ['./system-events-workflow.component.css'],
    standalone: false
})
export class SystemEventsWorkflowComponent implements OnInit {
  public loading: boolean = true;
  public emailEvents: SystemEvent[] = [];
  public EmailEvents: Events[] = [];
  public allemailEvents: Templates[] = [];
  public emailParameters: Parameters[] = [];
  public selectedEmailParameter: string | null = null; 
  public workflowEventsTriggered: WorkflowEventTriggered[] = [];
  public SystemEventActionTypeEnum = SystemEventActionTypeEnum;
  public emailEvent!: SystemEvent;
  public eventActionTypes: SystemEvent[] = [];
  public selectedEmailEvent: SystemEvent | null = null;
  public selectedActionType: SystemEvent | null = null;
  public filteredActions: SystemEventTriggeredActionDto[] = [];
  public apiName: string = '';
  public isTrigger: boolean = true;
  public apiEndpoint: string = '';
  public showDialog: boolean = false;
  public apiHttpMethod: SelectItem[] = [
    { label: 'POST', value: 'POST' },
    { label: 'PUT', value: 'PUT' },
    { label: 'GET', value: 'GET' },
    { label: 'DELETE', value: 'DELETE' },
  ];
  public selectedApiMethod: SelectItem | null = null;
  public apiHeaders: string = '{}';
  public apiRequestBodyTemplate: string = '{}';
  public isEmailSelected: boolean = false;
  public isApiSelected: boolean = false;
  public isSmsSelected: boolean = false;
  public checked: boolean = false;
  public ccAdmin: boolean = true;
  public includeInvoice: boolean = true;
  public selectedEmailTemplate: any | null = null;
  public selectedSmsTemplate: any | null = null;
  public EmailTemplates: Templates[] = [];
  public smsTemplates: SmsTemplatePayload[] = [];
  public isEditMode: boolean = false;
  public isDropdownDisabled: boolean = false;
  public isDisplayEmailTemplateDialog: boolean = false;
  public isDisplaySmsTemplateDialog: boolean = false;
  public isPredefined: boolean = false;
  public loadedEmailTemplateParameters: boolean = false;
  public selectedAction: SystemEventTriggeredActionDto | null = null;

  constructor(
    private workflowService: SystemEventsWorkflowService,
    private spinner: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private router: Router,
    private emailEventsService: EmailEventsService,
    private emailEventTypeService: EmailEventTypeService,
    private smsTemplateService: SmsTemplateService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.loadEmailEvents();
    this.loadWorkflowEventsTriggered();
    // this.fetchEmailTemplates();
    // this.fetchAllSmsTemplates();
  }

  private loadEmailEvents(): void {
    this.spinner.show();
    this.workflowService.fetchEvents().subscribe({
      next: (events) => {
        this.emailEvents = events;
        this.spinner.hide();
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToLoadEmailEvents'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error loading email events:', error);
      }
    });
  }

  private loadEventActionTypes(systemEventId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.workflowService.fetchEventActionTypes(systemEventId).subscribe({
        next: (actionTypes) => {
          this.eventActionTypes = actionTypes;
          this.spinner.hide();
          resolve();
        },
        error: (error) => {
          this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToLoadActionTypes'), NotificationTypes.Error);
          this.spinner.hide();
          console.error('Error loading action types:', error);
          reject();
        }
      });
    });
  }

  private loadEventActionTypesWithoutId(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.workflowService.fetchEventActionTypes('0').subscribe({
        next: (actionTypes) => {
          this.eventActionTypes = actionTypes;
          this.spinner.hide();
          resolve();
        },
        error: (error) => {
          this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToLoadActionTypes'), NotificationTypes.Error);
          this.spinner.hide();
          console.error('Error loading action types:', error);
          reject();
        }
      });
    });
  }

  private loadWorkflowEventsTriggered(): void {
    this.loading = true;
    this.spinner.show();
    this.workflowService.fetchWorkflowEventsTriggered().subscribe({
      next: (triggeredEvents) => {
        this.workflowEventsTriggered = triggeredEvents;
        this.spinner.hide();
        this.loading = false;
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToLoadTriggeredEvents'), NotificationTypes.Error);
        this.spinner.hide();
        this.loading = false;
        console.error('Error loading triggered events:', error);
      }
    });
  }

  public onEmailEventChange(): void {
    this.resetActionFields();
    if (this.selectedEmailEvent) {
      this.filteredActions = this.workflowEventsTriggered
        .flatMap(event => event.SystemEventTriggeredActionDtos)
        .filter(action => action.SystemEventId === this.selectedEmailEvent?.value);
      this.loadEventActionTypes(this.selectedEmailEvent.value).then(() => {
        this.selectedActionType = null;
        console.log('Email Event Changed, Action Fields Reset');
      }).catch(() => { });
    } else {
      this.filteredActions = [];
      this.selectedActionType = null;
      console.log('Email Event Cleared, Action Fields Reset');
    }
  }

  public onSmsTemplateChange(event: SmsTemplatePayload | null): void {
    this.selectedSmsTemplate = event;
    console.log('SMS Template Selected in Dropdown:', this.selectedSmsTemplate);
  }

  public onActionTypeChange(): void {
    this.isEmailSelected = false;
    this.isApiSelected = false;
    this.isSmsSelected = false;
    this.apiName = '';
    this.apiEndpoint = '';
    this.selectedApiMethod = null;
    this.apiHeaders = '{}';
    this.apiRequestBodyTemplate = '{}';

    if (!this.selectedActionType) {
      console.log('Action Type Cleared, Action-Specific Fields Reset');
      return;
    }

    const actionType = this.selectedActionType.label.toLowerCase();
    this.isEmailSelected = actionType.includes('email');
    this.isApiSelected = actionType.includes('api');
    this.isSmsSelected = actionType.includes('sms');

    if (this.isEmailSelected) {
      this.fetchEmailTemplates();
      console.log('Email Action Selected, EmailTemplates:', this.EmailTemplates, 'selectedEmailTemplate:', this.selectedEmailTemplate);
    } else if (this.isSmsSelected) {
      this.fetchAllSmsTemplates();
      console.log('SMS Action Selected, smsTemplates:', this.smsTemplates, 'selectedSmsTemplate:', this.selectedSmsTemplate);
    } else if (this.isApiSelected) {
      console.log('API Action Selected, apiName:', this.apiName, 'apiEndpoint:', this.apiEndpoint);
    }
  }

  private resetActionFields(): void {
    this.isEmailSelected = false;
    this.isApiSelected = false;
    this.isSmsSelected = false;
    this.apiName = '';
    this.apiEndpoint = '';
    this.selectedApiMethod = null;
    this.apiHeaders = '{}';
    this.apiRequestBodyTemplate = '{}';
    if (!this.isEditMode) {
      this.selectedEmailTemplate = null;
      this.selectedSmsTemplate = null;
    }
    console.log('Reset Action Fields - selectedEmailTemplate:', this.selectedEmailTemplate, 'selectedSmsTemplate:', this.selectedSmsTemplate, 'apiName:', this.apiName);
  }

  public onEmailTemplateChange(event: SaveTemplates | null): void {
    this.selectedEmailTemplate = event;
    console.log('Email Template Selected in Dropdown:', this.selectedEmailTemplate);
  }

  public updateTriggerEventAction(): void {
    if (!this.selectedEmailEvent?.value || !this.selectedActionType?.value) {
      console.log('Validation Failed - selectedEmailEvent:', this.selectedEmailEvent, 'selectedActionType:', this.selectedActionType);
      this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.systemEventAndActionTypeRequired'), NotificationTypes.Error);
      return;
    }
    const actionId = this.isEditMode && this.selectedAction?.Id ? this.selectedAction.Id : this.generateGuid();

    const updateRequest: UpdateTriggerEventActionRequest = {
      Id: actionId,
      systemEventId: this.selectedEmailEvent.value,
      systemEventActionTypeId: this.selectedActionType.value,
      emailTemplateId: this.isEmailSelected && this.selectedEmailTemplate?.Id ? this.selectedEmailTemplate.Id : '',
      smsTemplateId: this.isSmsSelected && this.selectedSmsTemplate?.Id ? this.selectedSmsTemplate.Id : '',
      apiEndpoint: this.isApiSelected ? this.apiEndpoint : '',
      apiHttpMethod: this.isApiSelected && this.selectedApiMethod?.value ? this.selectedApiMethod.value : '',
      apiHeaders: this.isApiSelected ? this.apiHeaders : '{}',
      apiRequestBodyTemplate: this.isApiSelected ? this.apiRequestBodyTemplate : '{}',
      userId: '',
      createdDate: this.isEditMode && this.selectedAction?.CreatedDate ? this.selectedAction.CreatedDate : new Date().toISOString(),
      ModifiedDate: new Date().toISOString(),
      apiName: this.isApiSelected ? this.apiName : '',
      isTrigger: this.isTrigger
    };

    console.log('Update Trigger Event Action Request:', updateRequest);
    console.log('SMS Template State - isSmsSelected:', this.isSmsSelected, 'selectedSmsTemplate:', this.selectedSmsTemplate);
    console.log('Email Template State - isEmailSelected:', this.isEmailSelected, 'selectedEmailTemplate:', this.selectedEmailTemplate);
    console.log('API State - isApiSelected:', this.isApiSelected, 'apiName:', this.apiName, 'apiEndpoint:', this.apiEndpoint);

    this.spinner.show();
    this.workflowService.updateTriggerEventAction(updateRequest).subscribe({
      next: (response) => {
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.success'), response.ResponseMessage || this.transloco.translate('systemEventsWorkflow.actionSavedSuccessfully'), NotificationTypes.Success);
          this.showDialog = false;
          this.loadWorkflowEventsTriggered();
          this.resetForm();
        } else {
          this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), response.ResponseMessage || this.transloco.translate('systemEventsWorkflow.failedToSaveAction'), NotificationTypes.Error);
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToSaveAction'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error saving action:', error);
      }
    });
  }

  private generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private resetForm(): void {
    this.selectedEmailEvent = null;
    this.selectedActionType = null;
    this.resetActionFields();
    this.isEditMode = false;
    this.isDropdownDisabled = false;
    this.selectedAction = null;
    this.isTrigger = true;
  }

  public fetchEmailTemplates(): void {
    this.spinner.show();
    this.workflowService.fetchAllTemplates().subscribe({
      next: (templates: Templates[]) => {
        this.EmailTemplates = templates.filter(template => !template.EventTypeViewModel.IsPredefined);
        console.log('Email Templates Loaded:', this.EmailTemplates);
        this.spinner.hide();
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchEmailTemplates'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error fetching email templates:', error);
      }
    });
  }

  public fetchAllSmsTemplates(): void {
    this.spinner.show();
    this.smsTemplateService.getAllSmsTemplates().subscribe({
      next: (smsTemplates: any[]) => {
        this.smsTemplates = smsTemplates;
        console.log('SMS Templates Loaded:', this.smsTemplates);
        this.spinner.hide();
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchSmsTemplates'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error fetching SMS templates:', error);
      }
    });
  }


  public async editTriggerEventAction(action: SystemEventTriggeredActionDto): Promise<void> {
    this.resetForm();
    this.selectedEmailEvent = this.emailEvents.find(event => event.value === action.SystemEventId) || null;
    this.isEditMode = true;
    this.isDropdownDisabled = true;
    this.selectedAction = action;
    this.isTrigger = action.IsTrigger;

    await this.loadEventActionTypesWithoutId();
    this.selectedActionType = this.eventActionTypes.find(type => type.value === action.SystemEventActionTypeId) || null;

    if (!this.selectedActionType) {
      console.error('Action type not found for ID:', action.SystemEventActionTypeId);
      return;
    }

    const actionType = this.selectedActionType.label.toLowerCase();
    this.isEmailSelected = actionType.includes('email');
    this.isApiSelected = actionType.includes('api');
    this.isSmsSelected = actionType.includes('sms');

    if (this.isApiSelected) {
      this.apiName = action.SystemEventActionApiCallDto?.ApiName || '';
      this.apiEndpoint = action.SystemEventActionApiCallDto?.ApiEndpoint || '';
      this.selectedApiMethod = this.apiHttpMethod.find(method => method.value === action.SystemEventActionApiCallDto?.ApiHttpMethod) || null;
      this.apiHeaders = action.SystemEventActionApiCallDto?.ApiHeaders || '{}';
      this.apiRequestBodyTemplate = action.SystemEventActionApiCallDto?.ApiRequestBodyTemplate || '{}';
    } else if (this.isEmailSelected) {
      await this.fetchEmailTemplates();
      const foundTemplate = this.EmailTemplates.find(template => template.Id === action.SystemEventActionEmailTemplateDto?.EmailTemplateId) || null;
      this.selectedEmailTemplate = foundTemplate ? Object.assign(new SaveTemplates(), foundTemplate, { Guid: foundTemplate.Id }) : null;
      console.log('Selected Email Template in edit:', this.selectedEmailTemplate, 'Email Templates:', this.EmailTemplates);
    } else if (this.isSmsSelected) {
      await this.fetchAllSmsTemplates();
      // FIX: Use the correct property to match SMS template
      const foundTemplate = this.smsTemplates.find(template => template.id === action.SmsTemplateDto?.Id) || null;
      this.selectedSmsTemplate = foundTemplate ? Object.assign({}, foundTemplate) : null;
      console.log('Selected SMS Template in edit:', this.selectedSmsTemplate, 'SMS Templates:', this.smsTemplates);
    }

    this.showDialog = true;
  }
  public onTriggerToggle(action: SystemEventTriggeredActionDto): void {
    const requestData = {
      id: action.Id,
      isTrigger: action.IsTrigger
    };

    this.spinner.show();
    this.workflowService.updateIsTriggerEventAction(requestData).subscribe({
      next: (response: any) => {
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.success'), this.transloco.translate('systemEventsWorkflow.triggerStatusUpdatedSuccessfully'), NotificationTypes.Success);
        } else {
          this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), response.ResponseMessage || this.transloco.translate('systemEventsWorkflow.failedToUpdateTriggerStatus'), NotificationTypes.Error);
          action.IsTrigger = !requestData.isTrigger;
        }
        this.spinner.hide();
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToUpdateTriggerStatus'), NotificationTypes.Error);
        action.IsTrigger = !requestData.isTrigger;
        this.spinner.hide();
        console.error('Error updating trigger status:', error);
      }
    });
  }

  public showTemplateDialog(): void {
    this.resetForm();
    this.isEditMode = false;
    this.isDropdownDisabled = false;
    this.loadEventActionTypesWithoutId().then(() => {
      this.fetchEmailTemplates();
      this.fetchAllSmsTemplates();
      this.showDialog = true;
    }).catch(() => { });
  }

  public onTriggerChange(event: InputSwitchOnChangeEvent): void {
    this.isTrigger = event.checked;
  }

  public addNewTriggerEventAction(event: WorkflowEventTriggered): void {
    this.resetForm();
    this.isEditMode = false;
    this.isDropdownDisabled = true;
    this.selectedEmailEvent = this.emailEvents.find(e => e.value === event.SystemEventId) || null;
    if (this.selectedEmailEvent) {
      this.loadEventActionTypes(this.selectedEmailEvent.value).then(() => {
        this.fetchEmailTemplates();
        this.fetchAllSmsTemplates();
        this.showDialog = true;
      }).catch(() => { });
    } else {
      this.showDialog = true;
    }
  }

  public onApiMethodChange(event: any): void {
    this.selectedApiMethod = event.value;
  }

  public showEditEmailTemplateDialog(eventId: string): void {
    this.getEmailTemplate(eventId);
    this.isEditMode = true;
    this.isDisplayEmailTemplateDialog = true;
  }

  public showEditSmsTemplateDialog(smsTemplateId: string): void {
    this.getSmsTemplate(smsTemplateId);
    this.isEditMode = true;
    this.isDisplaySmsTemplateDialog = true;
  }

  private getEmailTemplateParameters(eventId: string): void {
    this.loadedEmailTemplateParameters = false;
    this.emailEventTypeService.fetchEmailParameters(eventId).subscribe({
      next: (emailEvents: Parameters[]) => {
        this.emailParameters = emailEvents;
        this.loadedEmailTemplateParameters = true;
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchEmailParameters'), NotificationTypes.Error);
        console.error('Error fetching email parameters:', error);
      }
    });
  }

  private getEmailTemplate(eventId: string): void {
    this.spinner.show();
    this.emailEventsService.getEmailTemplate(eventId).subscribe({
      next: (emailTemplate: SaveTemplates) => {
        this.selectedEmailTemplate = emailTemplate || new SaveTemplates();
        this.selectedEmailTemplate.Guid = this.selectedEmailTemplate.Guid || eventId;
        this.spinner.hide();
        this.isPredefined = (this.selectedEmailTemplate as any).EventTypeViewModel?.IsPredefined ?? false;
        if (this.selectedEmailTemplate?.EmailEventId) {
          this.spinner.show();
          this.emailEventTypeService.fetchEmailevents(EmailEventsFilters.All).subscribe({
            next: (emailEvents: Events[]) => {
              this.EmailEvents = emailEvents.map(event => ({
                Id: event.Id,
                Name: event.Name,
                Description: event.Description,
                IsPredefined: event.IsPredefined,
                CreatedDate: event.CreatedDate,
                EmailParameterIds: event.EmailParameterIds,
                label: event.IsPredefined ? `${event.Name} (system)` : event.Name,
                value: event.Id,
              }));
              this.spinner.hide();
            },
            error: (error) => {
              this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchEmailEvents'), NotificationTypes.Error);
              this.spinner.hide();
              console.error('Error fetching email events:', error);
            }
          });
          this.getEmailTemplateParameters(this.selectedEmailTemplate.EmailEventId);
        }
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchEmailTemplate'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error fetching email template:', error);
      }
    });
  }

  private getSmsTemplate(smsTemplateId: string): void {
    this.spinner.show();
    this.smsTemplateService.getSmsTemplate(smsTemplateId).subscribe({
      next: (smsTemplate: any) => {
        // Convert the SMS template response to the format expected by the dialog
        this.selectedSmsTemplate = {
          Guid: smsTemplate.Id || smsTemplateId,
          HtmlText: smsTemplate.Text || '',
          EmailEventId: smsTemplate.SystemEventId || '',
          Subject: '' // SMS templates don't have subjects
        };

        this.spinner.hide();
        if (smsTemplate?.SystemEventId) {
          this.getEmailTemplateParameters(smsTemplate.SystemEventId);
        }
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchSmsTemplate'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error fetching SMS template:', error);
      }
    });
  }

  public fetchEmailEvents(): void {
    this.spinner.show();
    this.emailEventTypeService.fetchEmailevents(EmailEventsFilters.UserDefined).subscribe({
      next: (emailEvents: Events[]) => {
        this.EmailEvents = emailEvents.map(event => ({
          Id: event.Id,
          Name: event.Name,
          Description: event.Description,
          IsPredefined: event.IsPredefined,
          CreatedDate: event.CreatedDate,
          EmailParameterIds: event.EmailParameterIds,
          label: event.Name,
          value: event.Id
        }));
        this.spinner.hide();
      },
      error: (error) => {
        this.notificationsService.showNotification(this.transloco.translate('systemEventsWorkflow.error'), this.transloco.translate('systemEventsWorkflow.failedToFetchEmailEvents'), NotificationTypes.Error);
        this.spinner.hide();
        console.error('Error fetching email events:', error);
      }
    });
  }

  public onCloseEmailTemplateDialog($event: boolean): void {
    this.isEditMode = false;
    this.selectedEmailTemplate = new SaveTemplates();
    this.isDisplayEmailTemplateDialog = $event;
  }

  public onCloseSmsTemplateDialog($event: boolean): void {
    this.isEditMode = false;
    this.selectedSmsTemplate = null;
    this.isDisplaySmsTemplateDialog = $event;
  }
}